import { CheckCircleIcon } from "@heroicons/react/24/solid"

interface Props {
  text: string
  title: string
}

export default function BulletPoint({ text, title }: Props) {
  return (
    <div className="flex items-start gap-4">
      <CheckCircleIcon className="text-custom-teal h-8 w-8 shrink-0" />

      <div>
        <p className="text-custom-charcoal font-bold">{title}</p>
        <p className="text-gray-600">{text}</p>
      </div>
    </div>
  )
}
